import React from "react";
import { useSelector } from "react-redux";

import { Column, Row } from "@gamedev-web/gamedev-sdk-core";

import {
  CheckBoxOptionEnabler,
  FormCard,
  MultiLineTextField,
  RightSideWrapper,
} from "../../../components";
import * as commonStyles from "../../../components/commonStyles/commonStyles.module.css";
import { SubForm, SubFormNavigationProps } from "../../../components/SubForm";
import {
  gameConceptInputsMaxLength,
  gameInfoUgcInitialValues,
  useAaaGameInformationUgcSchema,
} from "../../../helpers/formValidation";
import { useStrings } from "../../../localization/localizationHelpers";
import { getIsSavingForm } from "../../../redux/selectors";
import {
  AaaGameInformationFormId,
  AaaGameInformationSubFormsId,
} from "../AaaGameInformationPageConstants";
import * as styles from "./UgcSubForm.module.css";

const UgcSubForm = (props: SubFormNavigationProps) => {
  const [
    ugcDescription1,
    ugcDescription2,
    ugcDescription3,
    ugcDescriptionPoint1,
    ugcDescriptionPoint2,
    ugcDescriptionPoint3,
    ugcDescriptionPoint4,
    ugcDescriptionPoint5,
    ugcDescriptionNote,
    ugcCheckbox,
    describeWhatTheUgcWillBe,
    ugcDescribeNote,
  ] = useStrings(
    "ugcDescription1",
    "ugcDescription2",
    "ugcDescription3",
    "ugcDescriptionPoint1",
    "ugcDescriptionPoint2",
    "ugcDescriptionPoint3",
    "ugcDescriptionPoint4",
    "ugcDescriptionPoint5",
    "ugcDescriptionNote",
    "ugcCheckbox",
    "describeWhatTheUgcWillBe",
    "ugcDescribeNote"
  );
  const validationSchema = useAaaGameInformationUgcSchema();
  const isSavingFormToCrm = useSelector(getIsSavingForm);

  return (
    <SubForm
      validateConfig={validationSchema}
      initialValues={gameInfoUgcInitialValues}
      formId={AaaGameInformationFormId}
      subFormId={AaaGameInformationSubFormsId.Ugc}
      {...props}
    >
      <RightSideWrapper rightSideComponent={<FormCard cardId={AaaGameInformationSubFormsId.Ugc} />}>
        <Row className={commonStyles.internalContainer}>
          <Column>
            <p className={styles.ugcText}>{ugcDescription1}</p>
            <p className={styles.ugcText}>{ugcDescription2}</p>
            <p className={styles.ugcText}>{ugcDescription3}</p>
            <ul className={styles.ugcText}>
              <li>{ugcDescriptionPoint1}</li>
              <li>{ugcDescriptionPoint2}</li>
              <li>{ugcDescriptionPoint3}</li>
              <li>{ugcDescriptionPoint4}</li>
              <li>
                {ugcDescriptionPoint5}
                <ul className={styles.ugcText}>
                  <li>{ugcDescriptionNote}</li>
                </ul>
              </li>
            </ul>
            <CheckBoxOptionEnabler
              name={"hasUserGeneratedShareableContent"}
              text={ugcCheckbox}
              isSaving={isSavingFormToCrm}
            >
              <MultiLineTextField
                title={describeWhatTheUgcWillBe}
                subtitle={ugcDescribeNote}
                name={"ugcDetails"}
                isRequiredField={true}
                isSaving={isSavingFormToCrm}
                maxLengthsByFieldName={gameConceptInputsMaxLength}
              />
            </CheckBoxOptionEnabler>
          </Column>
        </Row>
      </RightSideWrapper>
    </SubForm>
  );
};

export default UgcSubForm;
